<template>
  <div class="alert alert-danger row-margin">
    <ul class="list-unstyled">
      <li
        is="error-item"
        v-for="(error, index) in errorList()"
        :error="error"
        :index="index"
        :key="error.message"/>
    </ul>
  </div>
</template>

<script>
import ErrorItem from './ErrorItem.vue'

export default {
  components: {
      'error-item': ErrorItem
  },

  props: {
      errors: {
          type: Array,
          default: null
      },
      errorObject: {
          type: Object,
          default: null
      },
  },

  methods: {
      processKey: function(errors, obj, key) {
          if (key !== 'success') {
            const value = obj[key]
            if (value && (Array.isArray(value) || typeof value === "object")) {
                Object.keys(value).forEach(function (index) {
                    errors.push({key: key, index: index, message: value[index]})
                })
            } else {
                errors.push({key: key, message: value})
            }
          }
      },

      errorList: function() {
          const self = this
          const errors = this.errors || []
          const obj = this.errorObject
          if (obj) {
              if (obj.error) {
                  this.processKey(errors, obj, 'error')
              } else {
                  Object.keys(obj).forEach(function (key) {
                      self.processKey(errors, obj, key)
                  })
              }
          }
          return errors;
      }
  },
}
</script>